import { render } from "./Arena_ToolsMenu_V2.vue?vue&type=template&id=7f2b3a38&scoped=true"
import script from "./Arena_ToolsMenu_V2.vue?vue&type=script&lang=js"
export * from "./Arena_ToolsMenu_V2.vue?vue&type=script&lang=js"

import "./Arena_ToolsMenu_V2.vue?vue&type=style&index=0&id=7f2b3a38&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f2b3a38"]])

export default __exports__